import {
  ESTUDIOGRUPO_ERROR,
  ESTUDIOGRUPO_SUCCESS,
  ESTUDIOGRUPO_LOADING,
  ESTUDIOMASBUSCADO_SUCCESS,
  ESTUDIOMASBUSCADO_LOADING,
  ESTUDIOMASBUSCADO_ERROR,
  ESTUDIOMASBUSCADO_RESET,
  ESTUDIOGRUPO_RESET,
  ESTUDIOGRUPO_FILTRAR_POR_EDAD,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import estudioGrupoInitialState from "../initialStates/estudioGrupoInitialState";

const estudioGrupo = (state, { payload, type }) => {
  switch (type) {
    case ESTUDIOGRUPO_LOADING:
      return {
        ...state,
        estudioGrupo: {
          ...state.estudioGrupo,
          error: false,
          loading: true,
        },
      };
    case ESTUDIOGRUPO_SUCCESS:
      return {
        ...state,
        estudioGrupo: {
          ...state.estudioGrupo,
          loading: false,
          error: false,
          data: payload.dataFiltrada,
          dataOriginal: payload.dataOriginal,
        },
      };
    case ESTUDIOGRUPO_FILTRAR_POR_EDAD:
      return {
        ...state,
        estudioGrupo: {
          ...state.estudioGrupo,
          data: payload,
        },
      };
    case ESTUDIOGRUPO_ERROR:
      return {
        ...state,
        estudioGrupo: {
          ...state.estudioGrupo,
          error: payload,
          loading: false,
        },
      };
    case ESTUDIOMASBUSCADO_LOADING:
      return {
        ...state,
        estudiosMasBuscado: {
          ...state.estudiosMasBuscado,
          error: false,
          loading: true,
        },
      };
    case ESTUDIOMASBUSCADO_SUCCESS:
      return {
        ...state,
        estudiosMasBuscado: {
          ...state.estudiosMasBuscado,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case ESTUDIOMASBUSCADO_ERROR:
      return {
        ...state,
        estudiosMasBuscado: {
          ...state.estudiosMasBuscado,
          error: payload,
          loading: false,
        },
      };
    case ESTUDIOMASBUSCADO_RESET:
      return {
        ...state,
        estudiosMasBuscado: {
          ...state.estudiosMasBuscado,
          loading: false,
          error: null,
          data: null,
        },
      };
    case ESTUDIOGRUPO_RESET:
      return estudioGrupoInitialState;
    case RESET_PORTAL_CONTEXT:
      return estudioGrupoInitialState;

    default:
      return state;
  }
};

export default estudioGrupo;
